import React from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import {
  Employee,
  EmployeeFormInputProps,
} from 'src/components/EmployeeForm/EmployeeForm.utils';
import { Input } from 'src/components/Input/Input';
import { EMAIL_REGEX } from 'src/utilities/regexPatterns';

export function EmailInput({
  name,
  id,
  disabled = false,
  validation,
}: EmployeeFormInputProps): JSX.Element {
  const { errors, register } = useFormContext<Employee>();

  return (
    <Input
      label="Email"
      type="email"
      name={name}
      id={id}
      disabled={disabled}
      ref={register({
        required: 'Email is required',
        pattern: {
          value: EMAIL_REGEX,
          message: 'Email is invalid',
        },
        ...(validation && { validate: validation }),
      })}
      error={errors.email}
    />
  );
}
